import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Boot-time config check — print one clear console error if the build was
// shipped without REACT_APP_BACKEND_URL (which causes every API call to
// silently fail later). Runs only in the browser, never on server-rendered code.
if (typeof window !== "undefined" && !process.env.REACT_APP_BACKEND_URL) {
  console.error(
    "[bootstrap] REACT_APP_BACKEND_URL is not set. " +
    "All /api/* requests will fall through to the current origin and likely 404. " +
    "Set it in frontend/.env and rebuild."
  );
  const banner = document.createElement("div");
  banner.style.cssText = "position:fixed;top:0;left:0;right:0;z-index:99999;background:#fee2e2;color:#7f1d1d;font:600 12px system-ui;padding:8px;text-align:center;border-bottom:1px solid #f87171";
  banner.textContent = "⚠ Configuration error: REACT_APP_BACKEND_URL is not set. Build was shipped without a backend URL — check frontend/.env.";
  document.body && document.body.prepend(banner);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
